import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Sheet } from "../../../shared/phone/Sheet";

/**
 * Change one line, or write a new one, in a sheet: a 17px box, Cancel and Save in its bar. Why nothing saves
 * when the keyboard closes: putting the keyboard away must never make a version.
 */
export function LineSheet({
  title,
  initial,
  next,
  busy,
  onSave,
  onClose,
}: {
  title: string;
  initial: string;
  /** The version a save makes, "Yours v3". */
  next: string;
  busy: boolean;
  onSave: (value: string) => void;
  onClose: () => void;
}) {
  const [v, setV] = useState(initial);
  const box = useRef<HTMLTextAreaElement>(null);
  // Why a passive effect: the sheet takes focus in its own, which runs first; the box takes it after.
  useEffect(() => {
    const t = box.current;
    if (!t) return;
    t.focus({ preventScroll: true });
    t.setSelectionRange(t.value.length, t.value.length);
  }, []);
  useLayoutEffect(() => {
    const t = box.current;
    if (!t) return;
    t.style.height = "auto";
    t.style.height = `${Math.min(t.scrollHeight + 2, 300)}px`;
  }, [v]);
  return (
    <Sheet
      open
      onClose={onClose}
      title={title}
      className="lb-edit"
      left={
        <button type="button" className="pn-tbtn" onClick={onClose}>
          Cancel
        </button>
      }
      right={
        <button type="button" className="pn-tbtn strong" disabled={busy} onClick={() => onSave(v)}>
          {busy ? "Saving…" : "Save"}
        </button>
      }
    >
      <div className="pn-pad">
        <textarea ref={box} className="pn-inp lb-box" rows={3} aria-label={title} value={v} onChange={(e) => setV(e.target.value)} />
      </div>
      <p className="lb-ssub">Saving makes {next}. Goals already running keep the words they have.</p>
    </Sheet>
  );
}
